var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M14.2,11.3c-0.3,0-0.6,0.3-0.6,0.6v24.9c0,0.3,0.3,0.6,0.6,0.6h16.6c0.3,0,0.6-0.3,0.6-0.6V11.9 c0-0.3-0.3-0.6-0.6-0.6h-5.3v-3c0-0.3-0.3-0.6-0.6-0.6h-4.8c-0.3,0-0.6,0.3-0.6,0.6v3H14.2z M30.2,36.1H14.8V12.4h4.7v1.8h-1.7 c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6c0,0,0,0,0,0h9.4c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c0,0,0,0,0,0h-1.7 v-1.8h4.7V36.1z M24.3,8.9v5.3h-3.6V8.9H24.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M20.7,14.2h3.6V8.9h-3.6V14.2z M22.5,9.4c0.7,0,1.2,0.5,1.2,1.2c0,0.7-0.5,1.2-1.2,1.2 c-0.7,0-1.2-0.5-1.2-1.2C21.3,10,21.8,9.4,22.5,9.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M25.5,12.4v1.8h1.7c0,0,0,0,0,0c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6h-9.4c0,0,0,0,0,0 c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6h1.7v-1.8h-4.7v23.8h15.4V12.4H25.5z M16.6,31.4c-0.1,0-0.2,0-0.2,0 c-0.3-0.1-0.4-0.3-0.4-0.6c0-0.3,0.3-0.6,0.6-0.6h11.8c0.3,0,0.6,0.3,0.6,0.6c0,0.1,0,0.2,0,0.2c-0.1,0.3-0.3,0.4-0.6,0.4H16.6z  M25.5,33.1c0,0.3-0.3,0.6-0.6,0.6h-8.3c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h8.3C25.2,32.6,25.5,32.8,25.5,33.1z M27.2,28.4 c0,0.3-0.2,0.6-0.5,0.6c-0.3,0-0.6-0.3-0.6-0.6v-1.9c0-1.9-1.6-3.5-3.5-3.5h-0.2c-1.9,0-3.5,1.6-3.5,3.5v1.9c0,0.3-0.3,0.6-0.6,0.6 c-0.3,0-0.5-0.3-0.5-0.6v-1.9c0-1.8,1-3.5,2.7-4.3c-0.9-0.8-1.2-2.1-0.8-3.2c0.3-0.8,0.9-1.4,1.7-1.7c1.5-0.6,3.3,0.2,3.9,1.7 c0.4,1.1,0.1,2.4-0.8,3.2c1.7,0.8,2.7,2.5,2.7,4.3V28.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M22.5,18.4c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8C24.3,19.2,23.5,18.4,22.5,18.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#28B557",
  d: "M24.5,22.3c0.9-0.8,1.2-2.1,0.8-3.2c-0.6-1.5-2.3-2.3-3.9-1.7c-0.8,0.3-1.4,0.9-1.7,1.7 c-0.4,1.1-0.1,2.4,0.8,3.2c-1.7,0.8-2.7,2.5-2.7,4.3v1.9c0,0.3,0.2,0.6,0.5,0.6c0.3,0,0.6-0.3,0.6-0.6v-1.9c0-1.9,1.6-3.5,3.5-3.5 h0.2c1.9,0,3.5,1.6,3.5,3.5v1.9c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.5-0.3,0.5-0.6v-1.9C27.2,24.7,26.2,23,24.5,22.3z M22.5,21.9 c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8C24.3,21.1,23.5,21.9,22.5,21.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M29,31c0-0.1,0-0.2,0-0.2c0-0.3-0.3-0.6-0.6-0.6H16.6c-0.3,0-0.6,0.3-0.6,0.6c-0.1,0.3,0.1,0.5,0.4,0.6 c0.1,0,0.2,0,0.2,0h11.8C28.7,31.4,28.9,31.2,29,31z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M16.6,32.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h8.3c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6H16.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M22.5,11.9c0.7,0,1.2-0.5,1.2-1.2c0-0.7-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2 C21.3,11.3,21.8,11.9,22.5,11.9z"
}));

function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.c30bd54c9919c7896e552f5b150c62ff.svg";
export { ForwardRef as ReactComponent };